import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex } from '@mantine/core'

import { useMutationDeleteUserAddress } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { type CoreUserAddress } from '@flecto/types'
import {
  DataTable,
  type DataTableColumn,
  type DataTableProps,
  Icon,
  TextAddress,
  useMediaQuery,
} from '@flecto/ui'

import { useModalAddress } from '../../hooks/useModalAddress'

export type TableAddressesProps = Omit<
  DataTableProps<CoreUserAddress[]>,
  'columns'
> & {
  addresses?: CoreUserAddress[]
  onUpdateSuccess?: (address: CoreUserAddress) => void
  onRemoveSuccess?: (address: CoreUserAddress) => void
}

export function TableAddresses({ addresses, ...props }: TableAddressesProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_address' })

  const { mutateAsync: removeAddress, isLoading: isRemoving } =
    useMutationDeleteUserAddress()

  const { openModal } = useModalAddress()

  const { isDesktop } = useMediaQuery()

  const handleRemoveAddress = (address: CoreUserAddress) => {
    removeAddress({ addressId: address.id })
    props.onRemoveSuccess?.(address)
  }

  const columns: DataTableColumn<CoreUserAddress>[] = [
    {
      accessor: 'label',
      title: t('label_address'),
      width: isDesktop ? 250 : 150,
      render: (row) => <TextAddress withIcon={false} withLabel address={row} />,
    },
    {
      accessor: '',
      width: 70,
      textAlign: 'right',
      render: (row) => (
        <Flex align='center' justify='flex-end'>
          <ActionIcon size='sm' onClick={() => openModal({ address: row })}>
            <Icon icon={faEdit} size='xs' />
          </ActionIcon>
          <ActionIcon size='sm' onClick={() => handleRemoveAddress(row)}>
            <Icon icon={faTrashCan} size='xs' />
          </ActionIcon>
        </Flex>
      ),
    },
  ]

  const isLoading = props.isLoading || isRemoving

  return (
    <DataTable
      {...props}
      isLoading={isLoading}
      // @ts-expect-error page prop can be undefined
      records={addresses}
      // @ts-expect-error page prop can be undefined
      columns={columns}
    />
  )
}
